
import {AppInfoModalPropsType} from "./types";
import {ModalTexts} from "../../resources/locale";
import {AuthForm} from "../LoginModal/Forms";
import styles from "../LoginModal/LoginModal.module.scss";
import {Modal} from "../Modal";
import React from "react";
import {closeModal} from "react-url-modal";
import {useNavigate} from "react-router-dom";

export const AppInfo = (props:AppInfoModalPropsType) => {
  const { setIsOpen } = props;
  const isOpen = true
  const navigation = useNavigate()

  return (
    <Modal
      title={ModalTexts.appInfo.TITLE}
      subTitle={ModalTexts.appInfo.SUB_TITLE}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      closeModal={()=> {
        navigation("/")
        closeModal()
      }}
    >
    </Modal>
  )
}
